// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__QfPwd","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2mQtw"};